var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "authority-container" },
    [
      _c(
        "div",
        { staticClass: "authority-header" },
        [
          _c("h2", [_vm._v("权限配置管理")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleAddUser } },
            [_vm._v("添加人员权限")]
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: { data: _vm.userList, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { label: "菜单名称", prop: "menuName" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.menuName, function(menu) {
                    return _c(
                      "el-tag",
                      { key: menu, staticStyle: { "margin-right": "5px" } },
                      [_vm._v("\n          " + _vm._s(menu) + "\n        ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", { attrs: { label: "人员名称", prop: "name" } }),
          _c("el-table-column", {
            attrs: { label: "创建时间", prop: "created_at" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm
                            .$moment(scope.row.created_at)
                            .format("YYYY-MM-DD HH:mm:ss")
                        ) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "更新时间", prop: "updated_at" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm
                            .$moment(scope.row.updated_at)
                            .format("YYYY-MM-DD HH:mm:ss")
                        ) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "权限编辑状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "permission-status" },
                      [
                        _c("el-switch", {
                          attrs: { "active-text": "编辑权限" },
                          on: {
                            change: function(val) {
                              return _vm.handlePermissionChange(
                                scope.row,
                                "all",
                                "edit"
                              )
                            }
                          },
                          model: {
                            value: scope.row.editPermission,
                            callback: function($$v) {
                              _vm.$set(scope.row, "editPermission", $$v)
                            },
                            expression: "scope.row.editPermission"
                          }
                        })
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "text" },
                        on: {
                          click: function($event) {
                            return _vm.handleEdit(scope.row)
                          }
                        }
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "delete-btn",
                        attrs: { size: "mini", type: "text" },
                        on: {
                          click: function($event) {
                            return _vm.handleDelete(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogType === "add" ? "添加人员权限" : "编辑人员权限",
            visible: _vm.dialogVisible,
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "100px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "人员名称", prop: "name" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "请选择人员",
                        disabled: _vm.dialogType === "edit"
                      },
                      model: {
                        value: _vm.form.name,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "name", $$v)
                        },
                        expression: "form.name"
                      }
                    },
                    _vm._l(_vm.availableUsers, function(item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { label: item, value: item }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "菜单权限" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.form.menuName,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "menuName", $$v)
                        },
                        expression: "form.menuName"
                      }
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "资源管理" } }),
                      _c("el-checkbox", { attrs: { label: "员工信息" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "编辑权限" } },
                [
                  _c("el-switch", {
                    attrs: { "active-text": "允许编辑" },
                    model: {
                      value: _vm.form.editPermission,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "editPermission", $$v)
                      },
                      expression: "form.editPermission"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }